module.exports = __webpack_public_path__ + "static/media/reddit.12bb77d3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reddit.gif
// module id = 947
// module chunks = 0